export const isApple = () => {
  return /iP(ad|hone|od)|Mac/.test(window?.navigator?.platform)
}
